import React, { PureComponent } from 'react'

import classes from './AppraisalItem.scss'

import { connect } from 'react-redux'
import * as actions from '../../../store/actions/index'

import Aux from '../../../hoc/Auxiliary/Auxiliary'
import Card from '../../../components/UI/Card/Card'

import Alert from '../../../components/Alert/Alert'
import AppraisalItemHeader from '../../../components/PageContent/AppraisalItem/AppraisalItemHeader/AppraisalItemHeader'
import AppraisalItemBody from '../../../components/PageContent/AppraisalItem/AppraisalItemBody/AppraisalItemBody'
import EditModal from './EditModal/EditModal'
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../components/FilterModal/FilterModal'
import ActionBar from '../../../components/ActionBar/ActionBar'
import { updateFilterOptions, extractFilterOptions, updateObject } from '../../../helpers/utils'
import Spinner from '../../../components/UI/Spinner/Spinner'
import ImportModal from '../../../components/PageContent/AppraisalItem/ImportModal/ImportModal'
import { CardHeader } from '@material-ui/core'
import { withTranslate } from 'react-redux-multilingual'
import PageInfo from '../../../components/PageInfo/PageInfo'

class AppraisalItem extends PureComponent {
  state = {
    editModalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    importModalOpen: false,
    action: 'add',
    actionRecordId: null,
    importFile: null,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: null,
        configs: { placeholder: this.props.translate('company'), options: [], clearDisabled: true }
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: null,
        configs: { placeholder: this.props.translate('structure'), options: [] }
      },
      item_id: {
        label: this.props.translate('appraisalItem'),
        value: null,
        configs: { placeholder: this.props.translate('appraisalItem'), options: [] }
      }
    },
    structureId: null,
    companyOptions: null,
    itemOptions: null,
    structureOptions: null,
    collapse: [],
    collapseCheck: null,
    data: null,
    isValueGetZero: null
    // saveAno: false
  }

  componentDidMount() {
    this.props.fetchFilterOptions()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
    if (prevProps.imported !== this.props.imported && this.props.imported) {
      this.closeImportModal()
    }
  }

  componentWillUnmount() {
    this.props.clearSelectedRecord()
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data !== state.data) {
      let data = props.data.structures
      let collap = data.map(item => {
        const oldCollapseData = state.collapse.find(col => +col.structure_id === +item.structure_id)
        return {
          structure_id: item.structure_id,
          open: !!oldCollapseData?.open
        }
      })

      return {
        collapse: collap,
        data: props.data
      }
    }
    if (state.companyOptions !== props.companyOptions) {
      let firstCompany = ''
      if (props.companyOptions.length > 0 && !(state.editModalOpen || state.filterModalOpen)) {
        firstCompany = {
          key: props.companyOptions[0].company_id,
          value: props.companyOptions[0].company_id,
          label: `${props.companyOptions[0].company_code} - ${props.companyOptions[0].company_name}`
        }
        props.fetchAppraisalItems({
          company_id: firstCompany.value
        })
        props.filterAppraisalStructureOptions({ company_id: firstCompany.value })
        props.filterAppraisalItemOptions({ company_id: firstCompany.value })
      }

      return {
        filterControls: updateObject(state.filterControls, {
          company_id: {
            ...updateFilterOptions(
              props.companyOptions,
              state.filterControls.company_id,
              'company_id',
              'company_id',
              { code: 'company_code', name: 'company_name' },
              'Select Company'
            ),
            value: firstCompany
          }
        }),
        companyOptions: props.companyOptions
      }
    }

    if (props.itemOptions !== state.itemOptions) {
      return {
        filterControls: updateObject(state.filterControls, {
          item_id: updateFilterOptions(
            props.itemOptions,
            state.filterControls.item_id,
            'item_id',
            'item_id',
            { code: 'item_code', name: 'item_name' },
            'Select Item',
            false
          )
        }),
        itemOptions: props.itemOptions
      }
    }

    if (props.structureOptions !== state.structureOptions) {
      return {
        filterControls: updateObject(state.filterControls, {
          structure_id: updateFilterOptions(
            props.structureOptions,
            state.filterControls.structure_id,
            'structure_id',
            'structure_id',
            'structure_name',
            'Select Structure',
            false
          ),
          item_id: {
            ...state.filterControls.item_id,
            value: null
          }
        }),
        structureOptions: props.structureOptions
      }
    }

    return null
  }
  clearModal = () => {
    this.props.clearSelectedRecord()
    this.setState({
      actionRecordId: null
    })
    // if (!this.state.saveAno) {
    //   this.closeEditModal()
    // }
  }
  openModalHandler = (action, recordId, structureId, structureType, isValueGetZero) => {
    this.props.fetchEditOptions(this.state.filterControls.company_id.value?.value, structureId)
    if (recordId && ['edit'].includes(action)) {
      this.props.fetchAppraisalItemById(recordId)
    }

    this.setState({
      action: action,
      actionRecordId: recordId,
      structureType,
      structureId,
      isValueGetZero
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.openEditModal()
    }
  }

  openEditModal = () => {
    this.setState({
      editModalOpen: true
    })
  }

  closeEditModal = () => {
    this.props.clearSelectedRecord()
    this.setState({
      editModalOpen: false,
      actionRecordId: null,
      action: 'add',
      structureId: null,
      isValueGetZero: null
    })
  }

  deleteRecord = () => {
    const recordId = this.state.actionRecordId
    const filterOptions = extractFilterOptions(this.state.filterControls)

    this.props.deleteAppraisalItem(recordId, this.state.filterControls.company_id.value.value)
    this.props.filterAppraisalItemOptions(filterOptions)

    this.closeConfirmationModal()
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false,
      actionRecordId: null
    })
  }

  openConfirmationModal = recordId => {
    if (recordId) {
      this.setState({
        confirmationModalOpen: true
      })
    }
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: ''
    })
  }

  downloadHandler = () => {
    const filters = Object.entries(this.state.filterControls).reduce((filters, filterItem) => {
      const [filterKey, filterAttrs] = filterItem
      return { ...filters, [filterKey]: filterAttrs?.value?.value }
    }, {})
    this.props.downloadTemplate(filters)
  }

  exportHandler = () => {
    const filters = Object.entries(this.state.filterControls).reduce((filters, filterItem) => {
      const [filterKey, filterAttrs] = filterItem
      return { ...filters, [filterKey]: filterAttrs?.value?.value }
    }, {})
    this.props.exportAppraisalItems(filters)
  }

  formSubmitHandler = (recordData, type) => {
    if (this.state.action === 'add') {
      this.props.createAppraisalItem({
        ...recordData,
        structure_id: this.state.structureId,
        company_id: this.state.filterControls.company_id.value.value
      })
      // if (type) {
      //   this.setState({
      //     saveAno: true
      //   })
      // }
    } else if (this.state.action === 'edit') {
      this.props.updateAppraisalItem(
        this.state.actionRecordId,
        {
          ...recordData,
          structure_id: this.state.structureId,
          company_id: this.state.filterControls.company_id.value.value
        }
        // this.closeEditModal()
      )
    }
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.filterAppraisalStructureOptions({ company_id: filterValue?.value })
      this.props.filterAppraisalItemOptions({ company_id: filterValue?.value })
    }
    if (itemKey === 'structure_id') {
      this.props.filterAppraisalItemOptions({ structure_id: filterValue?.value })
    }
    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: {
          ...filterItem,
          value: filterValue
        }
      })
    })
  }

  filterRecords = () => {
    const filters = Object.entries(this.state.filterControls).reduce((filters, filterItem) => {
      const [filterKey, filterAttrs] = filterItem
      return { ...filters, [filterKey]: filterAttrs.value?.value || null }
    }, {})

    let check = filters.structure_id
    this.props.fetchAppraisalItems(filters)

    if (!filters?.structure_id) {
      check = this.props.data?.structures[0]?.structure_id
    }

    this.setState({
      collapseCheck: check,
      filterModalOpen: false
    })
  }

  fileChangeHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  fileSubmitHandler = () => {
    const filters = Object.entries(this.state.filterControls).reduce((filters, filterItem) => {
      const [filterKey, filterAttrs] = filterItem
      return { ...filters, [filterKey]: filterAttrs.value?.value }
    }, {})

    this.props.importAppraisalItems(this.state.importFile, filters)
    // this.closeImportModal()
  }

  toggleCollapse = id => {
    let collap = this.state.collapse.map(item => {
      if (item.structure_id === id) {
        return {
          ...item,
          open: !item.open
        }
      } else {
        return item
      }
    })
    let check = collap.find(item => item.open === true)

    this.setState({
      collapse: collap,
      collapseCheck: check?.structure_id
    })
  }

  render() {
    let appraisalItemBody = <Spinner />

    if (this.props.data) {
      appraisalItemBody = (
        <AppraisalItemBody
          structureData={this.props.data.structures}
          loading={this.props.loading}
          adding={(structureId, structureType, isValueGetZero) =>
            this.openModalHandler('add', null, structureId, structureType, isValueGetZero)
          }
          editing={(recordId, structureId, structureType, isValueGetZero) =>
            this.openModalHandler('edit', recordId, structureId, structureType, isValueGetZero)
          }
          deleting={recordId => this.openModalHandler('delete', recordId)}
          addDisabled={!this.props.pagePermission.is_add}
          editDisabled={!this.props.pagePermission.is_edit}
          deleteDisabled={!this.props.pagePermission.is_delete}
          collap={id => this.toggleCollapse(id)}
          collapseCheck={this.state.collapseCheck}
          open={this.state.collapse}
        />
      )
    }

    let importDisabled = true
    const pagePermission = this.props.pagePermission

    if (pagePermission.is_add && pagePermission.is_edit) {
      importDisabled = false
    }

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <Alert />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <ImportModal
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.fileChangeHandler}
          fileSubmit={this.fileSubmitHandler}
          selectedFile={this.state.importFile}
        />
        <EditModal
          open={this.state.editModalOpen}
          onHide={this.closeEditModal}
          onSave={this.formSubmitHandler}
          action={this.state.action}
          backdropClicked={this.closeEditModal}
          structure={this.state.structureType}
          isValueGetZero={this.state.isValueGetZero}
        />
        <div className={classes.AppraisalItemWrapper}>
          <Card>
            <CardHeader
              title={
                <ActionBar
                  exporting={this.exportHandler}
                  importing={this.openImportModal}
                  downloading={this.downloadHandler}
                  filtering={this.openFilterModal}
                  importDisabled={importDisabled}
                  leftContent={<PageInfo pageTranslateKey={'appraisalItem'} />}
                />
              }
            />
            <AppraisalItemHeader companyData={this.props.data} />
            {appraisalItemBody}
          </Card>
        </div>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    data: state.appraisalItems.data,
    loading: state.appraisalItems.loading,
    companyOptions: state.appraisalItems.companies,
    structureOptions: state.appraisalItems.structures,
    itemOptions: state.appraisalItems.kpis,
    saved: state.appraisalItems.saved,
    imported: state.appraisalItems.imported,
    success: state.appraisalItems.saved
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAppraisalItems: filterOptions =>
      dispatch(actions.fetchAppraisalItemsByCompanyId(filterOptions)),
    clearSelectedStructure: () => dispatch(actions.clearSelectedStructure()),
    fetchAppraisalItemById: recordId => dispatch(actions.fetchAppraisalItemById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedAppraisalItemRecord()),
    createAppraisalItem: recordData => dispatch(actions.createAppraisalItem(recordData)),
    updateAppraisalItem: (recordId, recordData) =>
      dispatch(actions.updateAppraisalItem(recordId, recordData)),
    deleteAppraisalItem: (recordId, companyId) =>
      dispatch(actions.deleteAppraisalItem(recordId, companyId)),
    importAppraisalItems: (importFile, filterOptions) =>
      dispatch(actions.importAppraisalItem(importFile, filterOptions)),
    exportAppraisalItems: filterOptions => dispatch(actions.exportAppraisalItems(filterOptions)),
    downloadTemplate: filterOptions =>
      dispatch(actions.downloadAppraisalItemTemplate(filterOptions)),
    filterAppraisalStructureOptions: filterOptions =>
      dispatch(actions.filterAppraisalStructureOptions(filterOptions)),
    filterAppraisalItemOptions: filterOptions =>
      dispatch(actions.filterAppraisalItemOptions(filterOptions)),
    fetchFilterOptions: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchEditOptions: (companyId, structureId) => {
      dispatch(actions.fetchKPITypeOptions({ company_id: companyId }))
      dispatch(actions.fetchParentKPIOptions({ structureId }))
      dispatch(actions.fetchValueTypeOptions())
      dispatch(actions.fetchUOMOptions({ company_id: companyId }))
      dispatch(actions.fetchPerspectiveOptions({ company_id: companyId }))
      dispatch(actions.fetchFunctionTypeOptions())
      dispatch(actions.fetchCompetencyTypeOptions())
      dispatch(actions.fetchAppraisalItemTags())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(AppraisalItem))
